import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { getClientId } from "@smartsheet/lodestar-utils";
import React, { forwardRef, InputHTMLAttributes } from "react";

const sharedStyles = css`
    box-sizing: border-box;
    font-size: inherit;
    font-weight: inherit;
    font-family: inherit;
    line-height: inherit;
    font-style: normal;
    color: inherit;

    // Just need a bit more space over the what the Inline already gives us.
    padding-left: 4px;
`;

const AutoSizeInputRoot = styled("span")`
    ${sharedStyles}

    display: inline-block;
    width: auto;
    /* height: auto; */
    position: relative;
    height: 28px;
`;

const AutoSizeInputSpacer = styled("span")`
    ${sharedStyles}
    visibility:hidden;
    display: inline;
    white-space: pre;
`;

const AutoSizeInputInput = styled("input")`
    ${sharedStyles}

    box-sizing:content-box;
    position: absolute;
    top: 0;
    bottom: 0;
    // Just need a bit more space over the what the Inline already gives us.
    left: 6px;
    width: 100%;

    margin: 0;
    padding: 0;

    border: none;
    outline: none;
    min-height: 28px;
    min-width: 1px;
    background-color: transparent;

    cursor: ${({ readOnly }) => (readOnly ? "default" : "text")};
`;

export interface AutoSizeInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "defaultValue" | "disabled"> {
    clientId: string | undefined;
    isReadonly: boolean;
}
export const AutoSizeInput = forwardRef<HTMLInputElement, AutoSizeInputProps>(
    ({ className, clientId, isReadonly, value, ...rest }, ref) => {
        return (
            <AutoSizeInputRoot className={className}>
                <AutoSizeInputSpacer>{value}</AutoSizeInputSpacer>
                <AutoSizeInputInput
                    readOnly={isReadonly}
                    value={value}
                    {...rest}
                    data-client-id={getClientId(clientId, "-input")}
                    ref={ref}
                />
            </AutoSizeInputRoot>
        );
    }
);

AutoSizeInput.displayName = "AutoSizeInput";
